import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

import type { TFormActionElement } from '../../hooks/use-actions';

export type TScenario = ({
    actions,
    values,
}: {
    actions: Record<string, TFormActionElement>;
    values: Record<string, unknown>;
}) => Record<string, unknown>;

const cc: TScenario = ({ actions, values }) => ({
    ...values,
    productType: (values.card as Record<string, string>)?.id ?? actions.productType,
    phone: getNumbersFromStr(values.phone as string),
    card: undefined,
    product: 'cc',
});

const dc: TScenario = ({ actions, values }) => ({
    ...values,
    productType: (values.card as Record<string, string>)?.id ?? actions.productType,
    phone: getNumbersFromStr(values.phone as string),
    product: 'dc',
});

const mg: TScenario = ({ values }) => ({
    ...values,
    phone: getNumbersFromStr(values.phone as string),
});

const pil: TScenario = ({ values }) => ({
    ...values,
    phone: getNumbersFromStr(values.phone as string),
    product: 'pil',
});

const sme: TScenario = ({ values }) => ({
    ...values,
    phone: getNumbersFromStr(values.phone as string),
});

export const scenarios: Record<string, TScenario> = {
    cc,
    dc,
    mg,
    'dc-short': dc,
    pil,
    sme,
};
